document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#dummy_button", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $container = $(this).closest(".product_form, .inline-quickshop");

    const $msgElement = $container.find('[id="veriant_select_msg"]');

    if ($msgElement.length > 0) {
      $msgElement.text(" : Please select size");

      $msgElement.addClass("error-text");
    }
  });

  // OPEN / ADD logic
  $(document).on("click", ".addtocard_hover", function (e) {
    e.stopPropagation();

    // 1. Capture the clicked + button and Context
    const $plusBtn = $(this);
    const $quickShop = $plusBtn.closest(".quick-shop-style--inline");
    const $form = $quickShop.find(".shopify-product-form");

    const swatchLength = $form.find('.variant-select option[value!=""]').length;

    if (swatchLength > 1) {
      $quickShop.find(".inline-quickshop").addClass("is-open");
    } else {
      if ($plusBtn.hasClass("is-loading")) return;

      const originalText = $plusBtn.html(); // Save the "+" symbol
      $plusBtn.addClass("is-loading");
      $plusBtn.html('<span class="btn-spinner"></span>'); // Swap content with spinner

      const $dummyBtn = $quickShop.find("#dummy_button");
      const $mainBtn = $quickShop.find("#main_button");

      $dummyBtn.addClass("hide");
      $mainBtn.removeClass("hide").addClass("active");

      $mainBtn.trigger("click");

      const $cartDrawer = $(".cart-drawer");

      // Function to revert button state
      const resetButton = () => {
        $plusBtn.html(originalText); // Put "+" back
        $plusBtn.removeClass("is-loading");
      };

      const drawerCheckInterval = setInterval(() => {
        if ($cartDrawer.hasClass("open")) {
          // Drawer is open! Stop spinning.
          clearInterval(drawerCheckInterval);
          resetButton();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(drawerCheckInterval);
        resetButton();
      }, 6000);
    }
  });

  $(document).on("click", ".inline-quickshop", function (e) {
    e.stopPropagation();
  });

  // CLOSE on outside click
  $(document).on("click", function () {
    $(".inline-quickshop.is-open").removeClass("is-open");
  });

  // CLOSE on X button click
  $(document).on("click", ".close_popupform", function () {
    $(".inline-quickshop.is-open").removeClass("is-open");
  });
});
